/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContrattoResDto } from '../../models/contratto-res-dto';

export interface ContrattiControllerGetOneContrattiById$Params {
  id: number;
}

export function contrattiControllerGetOneContrattiById(
  http: HttpClient,
  rootUrl: string,
  params: ContrattiControllerGetOneContrattiById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContrattoResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    contrattiControllerGetOneContrattiById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContrattoResDto>;
      }),
    );
}

contrattiControllerGetOneContrattiById.PATH = '/admin/contratti/id/{id}';
